import React from 'react';
import { FieldProps } from 'react-final-form';
import Input from 'components/final-form/Input';

export interface PasswordInput {
  name: string,
  component: any,
  validate?: any,
  type: "password"
}

export const passwordInput = (fields: FieldProps): PasswordInput => {
  return {
    name: fields.name,
    component: Input,
    validate: fields.validate,
    type: "password"
  }
};
